import { IonRouterOutlet } from "@ionic/react";
import { Redirect, Route } from "react-router-dom";
import { Routes } from "@/lib/router";
import { AuthForgotPassword } from "@/routes/auth/forgot-password";
import { AuthForgotPasswordReset } from "@/routes/auth/forgot-password/reset";
import { AuthRegister } from "@/routes/auth/register";
import { AuthRegisterSuccess } from "@/routes/auth/register/success";
import { AuthSignInPassword } from "@/routes/auth/sign-in";
import { AcceptInvitationToken } from "../auth/accept-invitation";

export function AuthRouter() {
  return (
    <IonRouterOutlet>
      {/* Accept invitation route */}
      <Route path={Routes.AuthAcceptInvite()} component={AcceptInvitationToken} />

      <Route exact path={Routes.AuthSignInPassword()} component={AuthSignInPassword} />
      <Route exact path={Routes.AuthForgotPassword()} component={AuthForgotPassword} />
      <Route path={Routes.AuthForgotPasswordReset()} component={AuthForgotPasswordReset} />
      <Route exact path={Routes.AuthRegister()} component={AuthRegister} />
      <Route exact path={Routes.AuthRegisterSuccess()} component={AuthRegisterSuccess} />

      <Redirect exact from={Routes.Auth()} to={Routes.AuthSignInPassword()} />
    </IonRouterOutlet>
  );
}
